var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("activator",[_c('v-btn',{attrs:{"small":"","color":"primary","disabled":_vm.disabledAccept,"outlined":""},on:{"click":_vm.accept}},[_vm._v("accept/kdr")])],{"accept":_vm.accept})],2)}
var staticRenderFns = []

export { render, staticRenderFns }